/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC, useEffect, useState} from 'react'
import DataTable from 'react-data-table-component'
import {Link} from 'react-router-dom'
import axios from 'axios'
import apiConnect from '../../api/apiConnect'
import Dropdown from 'react-bootstrap/Dropdown'
import {BsThreeDotsVertical} from 'react-icons/bs' // ไอคอนจุดสามจุดแนวตั้ง
import Swal from 'sweetalert2'
import {Modal} from 'react-bootstrap'

const TransferDeviceModal = ({
  userList,
  handleCloseModal,
  transferDeviceModal,
  selectedTransferDevice,
  setSelectedTransferDevice,
  trigger,
  setTrigger,
}) => {
  const [searchUser, setSearchUser] = useState('')

  const columnsUser = [
    {
      name: 'Profile',
      selector: (row) => row.image_profile,
      sortable: true,
      cell: (row) => {
        return (
          <div className='symbol symbol-40px'>
            <img src={row.image_profile} alt='' />
          </div>
        )
      },
    },
    {
      name: 'Name',
      selector: (row) => row.firstname,
      sortable: true,
      cell: (row) => {
        return <p>{row.firstname + ' ' + row.lastname}</p>
      },
    },
    {
      name: 'Email',
      selector: (row) => row.email,
      sortable: true,
      cell: (row) => {
        return <p>{row.email}</p>
      },
    },
  ]

  const filteredUserList = userList.filter((user) => {
    return (
      user.email.toLowerCase().includes(searchUser.toLowerCase()) ||
      user.firstname.toLowerCase().includes(searchUser.toLowerCase()) ||
      user.lastname.toLowerCase().includes(searchUser.toLowerCase())
    )
  })

  const handleRowClick = (row) => {
    setSelectedTransferDevice({
      ...selectedTransferDevice,
      newOwner: row,
    })
  }
  const rowStyles = [
    {
      when: (row) => row === selectedTransferDevice.newOwner,
      style: {
        backgroundColor: '#d7ecff',
        color: '#000',
      },
    },
  ]

  const handleTransferDevice = async () => {
    Swal.fire({
      html: `<p>ยืนยันการโอน '${selectedTransferDevice.name}' ไปให้ ${selectedTransferDevice.newOwner.firstname} ${selectedTransferDevice.newOwner.lastname} (${selectedTransferDevice.newOwner.email})</p>`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Transafer device',
      cancelButtonText: 'Cancel',
    }).then(async (result) => {
      if (result.isConfirmed) {
        //Sweet alert loading
        Swal.fire({
          title: 'Loading...',
          allowOutsideClick: false,
          onBeforeOpen: () => {
            Swal.showLoading()
          },
        })

        const payload = {
          deviceId: selectedTransferDevice.device_id,
          newOwner: selectedTransferDevice.newOwner.user_id,
          oldOwner: selectedTransferDevice.owner,
        }

        try {
          const response = await apiConnect.post('/v1/devices/transfer-owner', payload)

          Swal.fire({
            icon: 'success',
            title: 'Transfer device successfully!',
          }).then(() => {
            setTrigger(!trigger)
            handleCloseModal()
          })
        } catch (error) {
          console.error('Error fetching data:', error)
          Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: 'Something went wrong!',
          })
        }

        // Swal.fire('โอนเรียบร้อย!', '', 'success')
        // handleCloseModal()
      }
    })
  }

  return (
    <>
      <Modal show={transferDeviceModal} onHide={() => handleCloseModal()} centered size='lg'>
        <Modal.Header>
          <Modal.Title>
            <h3 className='fw-600'>Transfer Device</h3>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className='p-0'>
          <div className='card-body border-top p-9'>
            <h4 className='fw-600 mb-1'>
              กรุณาเลือกผู้ใช้งานที่ต้องการจะนำ '{selectedTransferDevice.name}' ไปให้
            </h4>

            <h5 className='fw-700 text-muted mb-3'>คลิกเลือกบนตารางเพื่อเลือกผู้ใช้งาน</h5>

            <div className='mb-3'>
              <label className='form-label'>Search</label>
              <input
                type='text'
                className='form-control'
                placeholder='Email, First name, Last name'
                value={searchUser}
                onChange={(e) => setSearchUser(e.target.value)}
              />
            </div>

            <div className='table-responsive'>
              <DataTable
                columns={columnsUser}
                data={filteredUserList}
                pagination
                paginationPerPage={25}
                paginationRowsPerPageOptions={[25, 50, 100]}
                defaultSortFieldId='lastUpdate'
                defaultSortAsc={false}
                highlightOnHover
                pointerOnHover
                conditionalRowStyles={rowStyles}
                onRowClicked={(row) => handleRowClick(row)}
              />
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          {selectedTransferDevice.newOwner && (
            <button onClick={() => handleTransferDevice()} className='btn btn-primary'>
              Transfer to {selectedTransferDevice.newOwner?.email}
            </button>
          )}
          <button onClick={() => handleCloseModal()} className='btn btn-secondary'>
            Close
          </button>
        </Modal.Footer>
      </Modal>
    </>
  )
}

export {TransferDeviceModal}
